import ArticleSearchIcon from './customicons/articleSearchIcon';
import AutoRepairIcon from './customicons/autoRepairIcon';
import BackArrowIcon from './customicons/backArrowIcon';
import BrokenHouseIcon from './customicons/brokenHouseIcon';
import CarIcon from './customicons/carIcon';
import CardExpandArrowIcon from './customicons/cardExpandArrowIcon';
import CheckBoxIcon from './customicons/checkBoxIcon';
import ClassicCarIcon from './customicons/classicCarIcon';
import CondoIcon from './customicons/condoIcon';
import CustomerServiceIcon from './customicons/customerServiceIcon';
import DirectionCarIcon from './customicons/directionCarIcon';
import DiscountIcon from './customicons/discountIcon';
import ExpandArrowIcon from './customicons/expandArrowIcon';
import FacebookIcon from './customicons/facebookIcon';
import FlagIcon from './customicons/flagIcon';
import ForwardArrowIcon from './customicons/forwardArrowIcon';
import HamburgerMenuIcon from './customicons/hamburgMenuIcon';
import HomeIcon from './customicons/homeIcon';
import HouseIcon from './customicons/houseIcon';
import InformationIcon from './customicons/informationIcon';
import InstagramIcon from './customicons/instagramIcon';
import JetskiIcon from './customicons/jetskiIcon';
import KeyIcon from './customicons/keyIcon';
import LayerIcon from './customicons/layerIcon';
import LinkedInIcon from './customicons/linkedInIcon';
import MapPinIcon from './customicons/mapPinIcon';
import MessageIcon from './customicons/messageIcon';
import MiniCarIcon from './customicons/miniCarIcon';
import MotorcycleIcon from './customicons/motorcycleIcon';
import OptionsIcon from './customicons/optionsIcon';
import PalmTreeIcon from './customicons/palmTreeIcon';
import PagesIcon from './customicons/pagesIcon';
import PawIcon from './customicons/pawIcon';
import PersonIcon from './customicons/pesronIcon';
import PinterestIcon from './customicons/pinterestIcon';
import QuestionMarkIcon from './customicons/questionmarkIcon';
import SealIcon from './customicons/sealIcon';
import ShieldIcon from './customicons/shieldIcon';
import ShieldCheckIcon from './customicons/shieldCheckIcon';
import SpecialCheckmarkIcon from './customicons/specialCheckmarkIcon';
import StarIcon from './customicons/starIcon';
import StormIcon from './customicons/stormIcon';
import TowIcon from './customicons/towIcon';
import TwitterIcon from './customicons/twitterIcon';
import UmbrellaIcon from './customicons/umbrellaIcon';
import WindShieldIcon from './customicons/windShieldIcon';
import WindShieldOutlinedIcon from './customicons/windshieldOutlined';
import YoutubeIcon from './customicons/youtubeIcon';
import ZoomInIcon from './customicons/zoomInIcon';

const icons = {
  articlesearch: ArticleSearchIcon,
  autorepair: AutoRepairIcon,
  backarrow: BackArrowIcon,
  brokenhouse: BrokenHouseIcon,
  car: CarIcon,
  cardexpandarrow: CardExpandArrowIcon,
  checkbox: CheckBoxIcon,
  classiccar: ClassicCarIcon,
  condo: CondoIcon,
  customerservice: CustomerServiceIcon,
  directioncar: DirectionCarIcon,
  discount: DiscountIcon,
  expandarrow: ExpandArrowIcon,
  facebook: FacebookIcon,
  flag: FlagIcon,
  forwardarrow: ForwardArrowIcon,
  hamburgermenu: HamburgerMenuIcon,
  home: HomeIcon,
  house: HouseIcon,
  information: InformationIcon,
  instagram: InstagramIcon,
  jetski: JetskiIcon,
  key: KeyIcon,
  layer: LayerIcon,
  linkedin: LinkedInIcon,
  mappin: MapPinIcon,
  message: MessageIcon,
  minicar: MiniCarIcon,
  motorcycle: MotorcycleIcon,
  options: OptionsIcon,
  palmtree: PalmTreeIcon,
  pages: PagesIcon,
  paw: PawIcon,
  person: PersonIcon,
  pinterest: PinterestIcon,
  questionmark: QuestionMarkIcon,
  seal: SealIcon,
  shield: ShieldIcon,
  shieldcheck: ShieldCheckIcon,
  specialcheckmark: SpecialCheckmarkIcon,
  star: StarIcon,
  storm: StormIcon,
  tow: TowIcon,
  twitter: TwitterIcon,
  umbrella: UmbrellaIcon,
  windshield: WindShieldIcon,
  windshieldoutlined: WindShieldOutlinedIcon,
  youtube: YoutubeIcon,
  zoomin: ZoomInIcon,
};

export default icons;
